// extracted by mini-css-extract-plugin
export var changedLabel = "Input-module--changed-label--07795";
export var changedValue = "Input-module--changed-value--f718c";
export var currency = "Input-module--currency--83ac4";
export var inputContainer = "Input-module--input-container--4026e";
export var originalFormatted = "Input-module--original-formatted--4be1d";
export var originalLabel = "Input-module--original-label--8b0a4";
export var originalValue = "Input-module--original-value--1cb0a";
export var percentage = "Input-module--percentage--afcd3";
export var slider = "Input-module--slider--3cce4";
export var sliderContainer = "Input-module--slider-container--0a3cc";
export var sliderGroup = "Input-module--slider-group--695ec";